import configErrors from 'data/errors/configErrors'
import generalErrors from 'data/errors/generalErrors'
/**
 * this serves as a central point to define the text of all generic app errors.
 * These are not the same as validation and other user data errors but are specific
 * to caught application errors such as a misconfiguration system.
 *
 * Errors should be in the format of X0000 where X is a letter used to identify
 * an error "section" such as C for configuration and 0000 is a four digit number
 * identifying a specific error within that section (number should be unique within
 * the section).
 *
 * Error objects should be added to the errors array in the section for which they
 * are defined. For an example and explanation of the required fields in an error
 * object see the genericError function which is used to return a default error
 * object when the correct error cannot be located.
 *
 * Once an error has been defined, it can be thrown using the
 * throwXtractError('X0000') action and passing it the appropriate code.
 **/

const genericError = {
  // Code -> First let for the section to which it belongs. In this case G for
  // general another example would be C for configuration. The letter should
  // be followed by a unique 4 digit number not yet used in this section.
  code: 'G0000',
  // user_message is the message to show the user in the popup
  user_message:
    "An unknown error has been detected. Please provide Xtract Solutions support a general description of what you were doing when this error occurred so that we can begin an investigation to ensure this doesn't happen again.",
  // support message explains to support how to resolve the issue.
  support_message:
    'Somewhere in the app one of the developers has thrown an error code that they did not define in data/xtractErrors.js a git issue should be submitted for this. A general description of what the user was doing prior to the error would be helpful if available.'
}

export default function getXtractError(error) {
  const section = error.substr(0, 1)
  switch (section.toUpperCase()) {
    case 'C':
      return findError(configErrors, error)
    case 'G':
    default:
      return findError(generalErrors, error)
  }
}

function findError(errors, code) {
  const foundError = errors.find(
    err => err.code.toUpperCase() === code.toUpperCase()
  )
  if (foundError == null) {
    return genericError
  } else {
    return foundError
  }
}
